// extracted by mini-css-extract-plugin
export default {"Tab":"AuthorTabBtn_Tab__Fd2mk"};